import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store';

/** Non-admins are sent to /dashboard. The server enforces admin rights independently. */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user?.isAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
